import React from 'react';
import { Typography } from '@material-ui/core';
import Badge from '../../shared_components/components/Badge';
import { STAGE_META } from '../constants';
import { TEXT, SURFACE } from '../../shared_components';

const StageProgress = ({ stageName, current, total }) => {
  const color = STAGE_META[stageName] || TEXT.secondary;
  const progressPct = total ? Math.round(((current || 0) / total) * 100) : 0;
  return (
    <div>
      <Badge label={stageName || '--'} color={color} style={{ marginBottom: 6 }} />
      <Typography variant="caption" style={{ display: 'block', color: TEXT.secondary, marginBottom: 4 }}>
        Stage {current}/{total} · {progressPct}%
      </Typography>
      <div style={{ width: 100, height: 6, borderRadius: 4, backgroundColor: SURFACE.divider }}>
        <div style={{ width: `${progressPct}%`, height: '100%', borderRadius: 4, backgroundColor: color }} />
      </div>
    </div>
  );
};

export default StageProgress;
